import * as React from 'react';
import {
  saveProductDto,
  saveProductFormData,
} from '../../../pages/produtos/save-produtos-model';

const FIELD_LABELS = {
  TIPO_PRODUTO: 'Tipo do produto',
  CODIGO_PRODUTO: 'Id do Portifólio/Produto no FOCO',
  NOME_PRODUTO: 'Nome do produto',
  OBJETIVO: 'Objetivo',
  PUBLICO: 'Publico do produto',
  CARGA_HORARIA: 'Carga horária',
  TEMPO_REALIZACAO: 'Tempo de realização',
  FUNCIONALIDADES: 'Funcionalidades',
  TAGS: 'Tags',
  TEMAS: 'Temas',
};

const objToArray = (obj) => {
  if (!obj) return [];
  return Object.keys(obj)
    .filter((key) => obj[key])
    .map((key) => ({ id: obj[key] }));
};

const parseNumber = (value) => {
  if (!value) return null;
  const cleaned = value.replace(/\D/g, '').replace(/\s/g, '');
  return parseInt(cleaned, 10);
};

const parseDecimal = (value) => {
  if (!value) return 0;
  return parseFloat(value.toString().replace(/\./g, '').replace(/,/g, '.'));
};

export const useProductValidation = (formData, isCompleteForm, notify) => {
  const validateForm = React.useCallback(() => {
    const commonRequired = {
      [FIELD_LABELS.TIPO_PRODUTO]:
        !formData.tipoProduto || formData.tipoProduto?.label === 'Selecione',
      [FIELD_LABELS.CODIGO_PRODUTO]: !formData.idPortfolio,
      [FIELD_LABELS.NOME_PRODUTO]: !formData.nome,
      [FIELD_LABELS.CARGA_HORARIA]: !formData.cargaHoraria,
    };

    const completeRequired = {
      ...commonRequired,
      [FIELD_LABELS.OBJETIVO]: !formData.objetivo,
      [FIELD_LABELS.PUBLICO]: !objToArray(formData.publico)?.length,
      [FIELD_LABELS.TEMPO_REALIZACAO]: !formData.tempoRealizacao,
      [FIELD_LABELS.FUNCIONALIDADES]: !objToArray(formData.funcionalidades)
        ?.length,
      [FIELD_LABELS.TAGS]: !formData.tags?.length,
      [FIELD_LABELS.TEMAS]: !objToArray(formData.temasSelecionadas)?.length,
    };

    const requiredFields = isCompleteForm ? completeRequired : commonRequired;
    const missingFields = Object.entries(requiredFields)
      .filter(([_, isEmpty]) => isEmpty)
      .map(([field]) => field)
      .join('; ');

    if (missingFields) {
      notify({
        message: 'Campos obrigatórios não preenchidos:',
        supportMessage: missingFields,
        color: 'attention',
      });
      return false;
    }
    return true;
  }, [formData, isCompleteForm, notify]);

  const createProductDTO = React.useCallback(
    (imageState, isUpdate, productId) => {
      const product = { ...saveProductDto };
      product.ativo = !!formData.ativo;
      product.cargaHoraria = parseNumber(formData.cargaHoraria);
      product.idPortfolio = formData.idPortfolio;
      product.idDisponibilizacao = formData.idDisponibilizacao;
      product.codigo = formData.codigoProdutoSas;
      product.codigoDisponibilizacaoSas = formData.codigoDisponibilizacaoSas;
      product.descricao = formData.descricao;
      product.exigeLoginPrevioTelegram = !!formData.isLoginTelegran;
      product.exigeLoginPrevioWhatsapp = !!formData.isLoginWhatsapp;
      product.funcionalidades = objToArray(formData.funcionalidades);
      product.linkAcessoTelegram = formData.linkTelegran;
      product.linkAcessoWhatsapp = formData.linkWhatsapp;
      product.modulos = formData.listaModulo;
      product.nome = formData.nome;
      product.objetivo = formData.objetivo;
      product.publicos = objToArray(formData.publico);
      product.tags = formData.tags;
      product.temas = objToArray(formData.temasSelecionadas);
      product.tempoRealizacao = parseNumber(formData.tempoRealizacao);
      product.tipoProduto = formData.tipoProduto;
      product.urlVideoMarketing = formData.url;
      product.valor = parseDecimal(formData.valor);

      if (isUpdate) {
        product.id = productId;
        product.imageCapaUpdated = imageState.updatedImage;
        product.imageCardUpdated = imageState.updatedImageCard;
      }

      if (imageState.imagem && imageState.imagem instanceof File) {
        product.fileCapa = imageState.imagem;
      }

      if (imageState.imagemCard && imageState.imagemCard instanceof File) {
        product.fileCard = imageState.imagemCard;
      }

      return saveProductFormData(product);
    },
    [formData],
  );

  return {
    validateForm,
    createProductDTO,
  };
};
